import { NeurologicWeaknessItem } from "@fusion-advantage/formlib"
import { DiagramWeakness } from "../l4/L4NeurologicWeaknessReview"
import { useMemo } from "react"
import { L1HumanoidMarker, L1ResizableHumanoidMarker, MarkerProps } from "../l1/L1HumanDiagramMarker"
import _ from 'lodash'
import { HUMAN_W, HumanDiagram, L1HumanoidBackVector, L1HumanoidFrontVector, L1HumanoidLabel, L1HumanoidRoot } from "../l1/L1HumanDiagram"
import { SideMarker } from "../l4/L4AmputationReview"
import { faSquareR, faSquareL } from "@fortawesome/pro-solid-svg-icons"
import styled, { CSSObject } from "@emotion/styled"

const L3NeurologicWeaknessHumanoidRoot = styled.div(({theme}): CSSObject => ({
	display: 'flex',
	flexDirection: 'row',
	padding: theme.spacing(3),
	justifyContent: 'space-between',
	width: '100%'
}))

type L3NeurologicWeaknessHumanoidProps = {
	models: NeurologicWeaknessItem[],
    diagramWeaknessModels: DiagramWeakness[],
	selectedSite: string|null,
	onSelectSite: (site: string) => void,
}

const L3NeurologicWeaknessHumanoid = ({ models, diagramWeaknessModels, selectedSite, onSelectSite }: L3NeurologicWeaknessHumanoidProps) => {
	const markerModels = useMemo(() => {
		const temp: {
			front: MarkerProps[],
			back: MarkerProps[],
		} = { front: [], back: [ ]}

		_.forEach(diagramWeaknessModels, weakness => {
			const active = (models.find(x => x.site === weakness.site) !== undefined) || selectedSite === weakness.site

			const marker = {
				cx: weakness.cx,
				cy: weakness.cy,
				rotateDeg: weakness.rotateDeg,
				active,
				onClick: () => onSelectSite(weakness.site),
				height: weakness.height,
				width: weakness.width,
				label: weakness.label,
			}

			if(weakness.diagram === HumanDiagram.Humanoid) {
				temp.front.push(marker)
			}
			else if(weakness.diagram === HumanDiagram.HumanoidBack) {
				temp.back.push(marker)
			}
		})

		return temp
	}, [models, diagramWeaknessModels, selectedSite, onSelectSite])

	return (
		<L3NeurologicWeaknessHumanoidRoot>
			<L1HumanoidRoot>
				<L1HumanoidLabel left={35} top={-30}>Individual Sites</L1HumanoidLabel>
				<L1HumanoidFrontVector />
				{markerModels.front.map((marker, idx) => (
					<L1HumanoidMarker key={idx} {...marker} />
				))}
				<SideMarker icon={faSquareR} cx={32} cy={28} />
				<SideMarker icon={faSquareL} cx={HUMAN_W - 32} cy={28} />
			</L1HumanoidRoot>
			<L1HumanoidRoot>
				<L1HumanoidBackVector />
				<L1HumanoidLabel left={35} top={-30}>Full / Hemi Sites</L1HumanoidLabel>
				{markerModels.back.map((marker, idx) => (
					(marker.height || marker.width) ? <L1ResizableHumanoidMarker key={idx} {...marker} /> :
					<L1HumanoidMarker key={idx} {...marker} />
				))}
				<SideMarker icon={faSquareL} cx={32} cy={28} />
				<SideMarker icon={faSquareR} cx={HUMAN_W - 32} cy={28} />
			</L1HumanoidRoot>
		</L3NeurologicWeaknessHumanoidRoot>
	)
}

export default L3NeurologicWeaknessHumanoid